
<template>
    <v-main> 
        <v-card v-if="loading">
            <v-card-title class="justify-center"><v-progress-circular indeterminate color="primary"></v-progress-circular></v-card-title>
            <v-card-title class="justify-center">loading ...</v-card-title>
        </v-card>
        <v-dialog>

        </v-dialog> 
        <v-card v-if="!loading">
            <v-card-title class="justify-center">Commission overview for {{ agentData.name }}</v-card-title>
            <v-divider class="mx-4"></v-divider>
            <v-row>
                <v-col cols="3" class="mx-4">
                    <select_status_codes :selected_statcodes="statCodesSelected" field="statCodesSelected" :isClearable="true" :visibleChips="8" @updateData="updateData" :localStorageItem="localStorageItemStatCom" />
                </v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>
            <v-card-text>
                <v-data-table 
                    :items="filterLines" 
                    :items-per-page="-1" 
                    :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
                    dense
                    :headers="headers">
                    <template v-slot:item="props">
                        <tr>
                            <td class="td-style">{{ props.item.newAcco ? props.item.huis_code + " (" + props.item.stat_code + ")" : "" }}</td>
                            <td class="td-style">{{ props.item.newAcco ? props.item.eign_naam + " (" + props.item.eign_plts + ")" : "" }}</td>
                            <td class="td-style">{{ props.item.newAcco ? props.item.huis_combi_planning : "" }}</td>
                            <!-- <td :innerHtml="getPlan(props.item.plan_codes)">{{ props.item.newAcco ? getPlan(props.item.plan_codes) : "" }}</td> -->
                            <td class="td-style" v-html="getPlan(props.item)"></td>
                            <td class="td-style">{{ props.item.hscj_van_dat }}</td>
                            <td class="td-style">{{ props.item.hscj_tm_dat }}</td>
                            <td class="td-style text-right">{{ props.item.hscj_marge_bedrag }}</td>
                            <td class="td-style text-right">{{ props.item.hscj_schaal }} <v-avatar @click="showCalculation(encrid, props.item.hscj_encrid)" size="19" color="primary" class="avclick mb-1"><v-icon color="white">mdi-information-variant-circle-outline</v-icon></v-avatar></td>
                            <td class="td-style text-right">{{ props.item.hscj_schaal_perc }}</td>
                            <td class="td-style">
                               <v-chip @click="showBookings(props.item)" color="primary pl-4" small>view bookings <v-icon class="pl-2" small>mdi-chevron-down-box-outline</v-icon></v-chip> 
                               <v-chip class="mx-4" @click="editScale(encrid, props.item.hscj_encrid)" color="warning" small v-if="props.item.allowEdit">edit scale</v-chip>
                               <btn_audit table="hscj" :encrid="props.item.hscj_encrid" :size=25 tooltip="audit of scale" v-if="props.item.allowEdit"/>
                            </td>
                        </tr>
                    </template>
                </v-data-table>                
            </v-card-text>
        </v-card>
        <navBar title="Ares - Agents" :home="true" type="agents"/>    
        <scaleCalculation ref="scaleCalculation"/>
        <viewAgentBookings ref="viewAgentBookings"/>
        <scaleEdit ref="scaleEdit" @getAgentScaleOverview="getAgentScaleOverview"/>
    </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import btn_audit from "@/components/ui/buttons/btn_audit.vue";
    import scaleCalculation from "@/views/task/agent/ovrz/scaleCalculation.vue";
    import viewAgentBookings from "@/views/task/agent/ovrz/viewAgentBookings.vue";
    import select_status_codes from "@/components/ui/selectors/select_status_codes.vue"
    import scaleEdit from "@/views/task/agent/ovrz/scaleEdit.vue";
    
    export default {
        components: {
            navBar,
            scaleCalculation,
            viewAgentBookings,
            scaleEdit,
            btn_audit,
            select_status_codes,
        },
        props: {
            encrid: {
                type: String,
                required: true,
            }
        },
        data() {
            return {
                localStorageItemStatCom: 'statcodes',
                results: false,
                statCodesSelected: [],
                loading: true,
                headers: [
                    {text: "Accommodation", value: "huis_code", sortable: false},
                    {text: "Owner", value: "eign_naam", sortable: false},
                    {text: "Combi", value: "huis_combi_planning", sortable: false},
                    {text: "Plancodes", value: "plan_codes", sortable: false},
                    {text: "From", value: "hscj_van_dat", sortable: false},
                    {text: "Until", value: "hscj_tm_dat", sortable: false},
                    {text: "Amount", value: "hscj_marge_bedrag", sortable: false, align: "end"},
                    {text: "Scale next year", value: "hscj_schaal", sortable: false, align: "end"},
                    {text: "Percentage next year", value: "hscj_schaal", sortable: false, align: "end"},
                    {text: "", value: ""},
                ],
                agentData: {
                    name: "",
                    accoLines: [],
                },
                filterLines: [],
            }  
        },
        mounted() {
            this.getAgentScaleOverview();
        },
        methods: {
            getAgentScaleOverview() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/agent/ovrz/getAgentScaleOverview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAgentScaleOverview"
                    },
                    getAgentScaleOverview: {
                        gebr_encrid: this.encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.agentData = res.data.getAgentScaleOverview;
                        this.loading = false;
                        localStorage.setItem(this.localStorageItemStatCom, this.statCodesSelected);
                        this.filterAccos();
                    }
                });
            },
            showBookings(accoLine) {
                this.$refs.viewAgentBookings.openDialog(this.encrid, accoLine);
                // accoLine.showBookings = !accoLine.showBookings;
                // if ((accoLine.showBookings) && (accoLine.huovs.length === 0)) {
                //     this.getAgentScaleOverviewHuov(accoLine);
                // }
            },
            getAgentScaleOverviewHuov(accoLine) {
                this.$axios.post("ares/json/ares/syst/agent/ovrz/getAgentScaleOverviewHuov.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAgentScaleOverviewHuov"
                    },
                    getAgentScaleOverviewHuov: {
                        gebr_encrid: this.encrid,
                        hscj_encrid: accoLine.hscj_encrid,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        accoLine.huovs = res.data.getAgentScaleOverviewHuov;
                    }
                });
            },
            showCalculation(encrid, hscj_encrid) {
                this.$refs.scaleCalculation.openDialog(encrid, hscj_encrid);
            },
            editScale(encrid, hscj_encrid) {
                this.$refs.scaleEdit.openDialog(encrid, hscj_encrid);
            },
            getPlan(item) {
                if (item.newAcco) return item.plan_codes.split(",").join("<br>");
                return "";
            },
            updateData(data) {
                this[data.field] = data.value;
                this.filterAccos();
            },
            filterAccos() {
                console.log(this.statCodesSelected);
                if (this.statCodesSelected.length === 0) {
                    this.filterLines = this.agentData.accoLines;
                    return;
                }
                if (this.statCodesSelected.length === 1) {
                    if (this.statCodesSelected[0] === "") {
                        this.filterLines = this.agentData.accoLines;
                        return;
                    }
                }
                let filterAccosNew = [];
                for (let iIndex1=0;iIndex1<this.agentData.accoLines.length;iIndex1++) {
                    let stat = this.agentData.accoLines[iIndex1].stat_code;
                    for (let iIndex2=0;iIndex2<this.statCodesSelected.length;iIndex2++) {
                        if (stat === this.statCodesSelected[iIndex2]) {
                            filterAccosNew.push(this.agentData.accoLines[iIndex1]);
                            break;
                        }
                    }
                }
                this.filterLines = filterAccosNew;
            },
        }
    };

</script> 

<style scoped>
    .avclick {
        cursor: pointer;
    }
    .td-style {
        vertical-align: top;

    }
</style>
